import { Kaggle } from "@kaggle/sdk";
import { Version } from "../../../../types/entities/version";
import { RunActionKey, VersionActionKey } from "../../../actions/ActionKeys";
import { RunsAction, SetRunStatusAction } from "../../../actions/runs";
import {
  FetchVersionsSuccessAction,
  VersionsAction,
} from "../../../actions/versions";

import KernelWorkerStatus = Kaggle.Sdk.Kernels.KernelWorkerStatus;

export interface State {
  [id: number]: Version;
}

/** Case reducer to add new run. */
const addVersions = (
  state: State,
  action: FetchVersionsSuccessAction
): State => {
  const newState = { ...state };

  for (const version of action.payload.versions) {
    newState[version.id] = version;
  }

  return newState;
};

/* Updates the run status of a 'Version' with the matching runId. */
const mergeRunStatus = (state: State, action: SetRunStatusAction): State => {
  const { id: runId, status } = action.payload;
  const newState = { ...state };

  for (const key of Object.keys(state)) {
    const version = state[key as any];
    if (version.runId === runId) {
      version.status = status;
      version.succeeded = status === KernelWorkerStatus.COMPLETE;
    }
  }

  return newState;
};

/** Reducer used to manage kernel runs. */
export const versions = (
  state: State = {},
  action: VersionsAction | RunsAction
): State => {
  switch (action.type) {
    case VersionActionKey.FETCH_VERSIONS_SUCCESS:
      return addVersions(state, action);
    case RunActionKey.SET_RUN_STATUS:
      return mergeRunStatus(state, action);
    default:
      return state;
  }
};
